import walletApi from 'api/walletApi';
import { useAppTranslation, useErrTranslation } from 'app/hooks';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import { useMessageSuccess } from 'hooks/useMessageSuccess';
import useThemes from 'hooks/useThemes';
import { UserBankbookResponseModel } from 'models/wallet';
import React, { useEffect, useState } from 'react';
import AddUserBankbook from './UserBankbook/AddUserBankbook';
import ListUserBankbook from './UserBankbook/ListUserBankbook';
import useUserDetail from 'hooks/useUserDetail';

interface BankingProps {}

const Banking: React.FunctionComponent<BankingProps> = (props) => {
  const { currentTheme } = useThemes();
  const handleResponseError = useHandleResponseError();
  const t = useAppTranslation();
  const et = useErrTranslation();
  const { showToast, contextHolder } = useMessageSuccess();
  const [userBankbooks, setUserBankbooks] = useState<UserBankbookResponseModel[] | undefined>([]);
  const [isAdding, setIsAdding] = useState<boolean>(false);
  const { currentUser } = useUserDetail();

  const getUserBankbooks = async () => {
    const { ok, body } = await walletApi.getUserBankbooks();
    if (ok) {
      setUserBankbooks(body);
    }
  };

  const onDelete = async (id: number) => {
    const { ok, error } = await walletApi.deleteUserBankbooks(id);
    if (ok) {
      getUserBankbooks();
    }

    if (error) handleResponseError(error);
  };

  const onBack = () => {
    getUserBankbooks();
    setIsAdding(false);
  };

  const handleOpenAddNewBankbook = () => {
    setIsAdding(true);
  };

  useEffect(() => {
    getUserBankbooks();
  }, [currentUser]);
  return (
    <div className="payment-methods primary-text-color items-center-important">
      <div className="flex justify-center items-center gap-3 w-full ">
        <div className="center-content-col gap-2 primary-text-color user-banking-fom">
          {isAdding ? (
            <AddUserBankbook onBack={onBack} />
          ) : (
            <>
              <ListUserBankbook onDeleteUserBankbook={onDelete} userBankbooks={userBankbooks} />
              <button
                className={`mt-2 button-generate add-user-bank__btn`}
                type="button"
                onClick={handleOpenAddNewBankbook}
              >
                {t('userBankbook.addNewBankbook')}
              </button>
            </>
          )}
        </div>

        {contextHolder}
      </div>
    </div>
  );
};

export default Banking;
